<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    @import "../common/style/variables";
    .navbar {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background: #fff;
        z-index: 1000;
        padding-left: calc(100vw - 100%);
        box-shadow: 0 2px 4px 0 #DDDDDD;
        .container {
            position: relative;
            width: 100%;
            min-width: 1200px;
            height: 100px * @scaleRate;
            .logo {
                cursor: pointer;
                position: absolute;
                bottom: 4.25px;
                margin-left: 230px * @scaleRate;
                img {
                    width: 100px * @scaleRate;
                    height: 44px * @scaleRate;
                }
            }
        }
    }
    .status {
        font-size: 15px;
        color: #111111;
        font-weight: bold;
        padding: 64px * @scaleRate 0 32px * @scaleRate;
        background-color: rgb(244,245,246);
    }
    main {
        width: 79.2%;
        margin: 100px * @scaleRate auto 0;
        .process {
            padding: 61px * @scaleRate 0 37px * @scaleRate;
        }
        .next {
            margin-top: 163px * @scaleRate;
            display: flex;
            justify-content: center;
            img {
                cursor: pointer;
                width: 120px * @scaleRate;
            }
        }
        .form-box {
            height: 830px * @scaleRate;
            overflow: hidden;
            background-color: #fff;
            .form-photo {
                overflow: hidden;
                padding: 110px * @scaleRate 200px * @scaleRate 0;
                .upload {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
                .up-box {
                    width: 450px * @scaleRate;
                    .img-upload-box {
                        width: 450px * @scaleRate;
                        height: 306px * @scaleRate;
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        background-size: cover;
                        background-position: center;
                        img {
                            width: 450px * @scaleRate;
                        }
                        p {
                            padding-top: 30px * @scaleRate;
                            font-size: 15px;
                            color: #111111;
                            font-weight: bold;
                        }
                    }
                }
            }
            .form-input-box {
                padding-top: 80px;
            }
            button.code {
                background: #9B9B9B;
                border-radius: 3px;
                width: 150px * @scaleRate;
                height: 60px * @scaleRate;
                color: #fff;
                font-size: 14px;
                margin-left: 30px * @scaleRate;
                letter-spacing: 1px;
            }
            button.code[disabled] {
                background-color: #ccc;
                color: #666;
            }
            button.active {
                background-color: #4B89F3 ;
                color: #fff;
            }
            .tip {
                font-size: 10px;
                color: #FF626A;
                position: absolute;
                right: 50px;
                top: 5px;
            }
        }
    }
    .form-state {
        // padding: 110px * @scaleRate 0 376px * @scaleRate;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        .wrapper-box {
            display: flex;
            align-items: center;
            flex-direction: column;
        }
        img{
            width: 290px * @scaleRate;
        }
        p{
            font-size: 14px;
            font-weight: bold;
            color: #111111;
            padding: 40px * @scaleRate 0 166px * @scaleRate;
        }
    }
    .common-btn {
        width: 120px * @scaleRate;
        height: 40px * @scaleRate;
        background: #4B89F3;
        color: #fff;
        font-size: 12px;
    }
    .toast {
        position: fixed;
        top: 100px;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1001;
        width: 100%;
        &-content {
            position: absolute;
            width: 400px;
            height: 60px;
            top: 50%;
            left: 50%;
            margin-left: -200px;
            margin-top: -40px;
            line-height: 60px;
            overflow: hidden;
            background: rgba(0, 0, 0, .5);
            border-radius: 4px;
            text-align: center;
            font-size: 30px;
            color: #000;
        }
    }
</style>

<!--<style lang="less">
    @import "../common/style/variables";
    .form-photo {
        .ivu-upload-drag {
            overflow: visible;
        }
    }
    .ivu-upload-drag {
        border: none;
    }
    .ivu-upload-drag:hover {
        border: none;
    }
    .form-box {
        .ivu-form-item-content {
            align-items: center;
            height: 60px * @scaleRate;
        }
        .ivu-input {
            padding: 0 20px * @scaleRate;
            border-radius: 3px;
            font-size: 12px;
        }
        .label {
            font-size: 15px;
            color: #111111;
            flex-shrink: 0;
            // width: 150px;
            font-weight: bold;
            margin-right: 30px * @scaleRate;
        }
        .ivu-form-item-required .ivu-form-item-label:before{
            content: '' !important;
        }
        .ivu-form-item{
            margin-bottom: 30px * @scaleRate;
            position: relative;
            width: 750px * @scaleRate;
        }
        .code-form {
            .ivu-input {
                width: 270px * @scaleRate !important;
            }
        }
        .ivu-input-wrapper {
            // width: 450px * @scaleRate;
            .ivu-input {
               width: 450px * @scaleRate;
            }
        }
    }
    .ivu-form-item-error-tip{
        left: 100px;
    }
</style>-->

<template>
    <div class="forgetPwd">
        <nav class="navbar">
            <div class="container container-header" :class="clientWidth <= 1440 ? 'minScreen' : ''">
                <div class="logo">
                    <img src="../common/image/logo.png" alt="logo">
                </div>
            </div>
        </nav>
        <main>
            <p class="status">找回密码</p>
            <div class="form-box">
                <div class="form-input-box">
                    <Form ref="registerForm" :model="form" :rules="rule">
                        <Form-Item  prop="username">
                            <span class="label">手&nbsp;机&nbsp;号&nbsp;:</span>
                            <Input type="number" v-model="form.username" placeholder="请输入正确的手机号"/>
                        </Form-Item>
                        <Form-Item prop="code" class="code-form">
                            <span class="label">验&nbsp;证&nbsp;码&nbsp;:</span>
                            <Input type="number" style="width: 202.5px" v-model="form.code" placeholder="请输入正确的验证码"/>
                            <button @click="getSms" :disabled="isDisabled" :class="{active: !isDisabled && !disabled}" class="code" type="button">{{codeTxt}}</button>
                        </Form-Item>
                        <Form-Item  prop="password">
                            <span class="label">密&nbsp;&nbsp;&nbsp;码&nbsp;&nbsp;&nbsp;&nbsp;:</span>
                            <Input type="password" v-model="form.password" placeholder="请输入密码"/>
                        </Form-Item>
                        <Form-Item prop="rePassword">
                            <span class="label">确认密码:</span>
                            <Input type="password" v-model="form.rePassword" placeholder="请再次输入密码"/>
                        </Form-Item>
                        <Form-Item>
                            <div class="next-middle" style="margin-top: 90px;margin-left: 97px;">
                                <button style="margin-right: 150px;" @click="goPrev" type="button" class="common-btn">返回</button>
                                <button @click="submit" type="button" class="common-btn">提交</button>
                            </div>
                        </Form-Item>

                    </Form>
                </div>
            </div>
        </main>

        <div v-show="toast.show" class="toast">
            <div class="toast-content">
                {{toast.text}}
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data () {
      const validateRePwd = (rule, value, callback) => {
        if (this.form.password !== this.form.rePassword) {
          return callback(new Error('两次密码不一致'));
        }
        callback()
      }
      const validateCode = (rule, value, callback) => {
        // 没有手机号或验证码则不校验
        if (this.form.code === '' || this.form.username === '') {
          callback()
          return
        }
        let _param = {
          code: this.form.code,
          phoneNumber: this.form.username
        }
        this.$ajax.checkCode(_param).then(res => {
          if (res.code === '0') {
            if (res.data === true) {
              callback()
            } else {
              callback(new Error('验证码不正确'));
            }
          } else {
            callback(new Error(res.msg));
          }
        })
      }
      return {
        rule: {
          username: [
            {required: true, message: '请输入手机号', max: 11, trigger: 'blur'},
            {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, max: 11, message: '请输入正确的手机号', trigger: 'blur' }
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'},
            {pattern: /^[A-Za-z0-9]{6,20}$/, max: 20, min: 6, message: '请输入正确的密码', trigger: 'blur' }
          ],
          rePassword: [
            {required: true, message: '请输入确认密码', trigger: 'blur'},
            {pattern: /^[A-Za-z0-9]{6,20}$/, max: 20, min: 6, message: '请输入正确的确认密码', trigger: 'blur' },
            {validator: validateRePwd, trigger: 'blur' }
          ],
          code: [
            {required: true, message: '请输入验证码', trigger: 'blur'},
            {validator: validateCode, trigger: 'blur' }
          ]
        },
        toast: {
          show: false,
          text: '',
          timer: undefined
        },
        isDisabled: false,
        countdown: 60,
        codeTxt: '获取验证码',
        form: {
          code: '',
          password: '',
          username: '', // 手机号，不要问我为什么
          rePassword: ''
        }
      }
    },
    computed: {
      disabled () {
        return !/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.form.username)
      }
    },
    methods: {
      // 返回登录
      goPrev () {
        this.$router.back()
      },
      // 提交表单
      submit () {
        this.$refs['registerForm'].validate((valid) => {
          if (valid) {
            let _param = Object.assign(this.form, this.photoForm)
            _param.phoneNum = _param.username
            this.$ajax.updatePassword(_param).then(res => {
              if (res.code === '0') {
                this.showToast('修改成功')
                setTimeout(() => {
                  this.$router.push('/login')
                }, 1000)
              } else {
                this.showToast(res.msg)
              }
            })
          }
        })
      },
      // 短信倒计时
      countDown: function () {
        let _this = this
        if (_this.countdown == 0) {
          _this.codeTxt = '重新获取'
          _this.isDisabled = false
          _this.countdown = 60
          return
        } else {
          _this.isDisabled = true
          _this.codeTxt = this.countdown + 's'
          _this.countdown--
        }
        setTimeout(function () {
          _this.countDown()
        }, 1000)
      },
      // 短信接口获取
      async getSms () {
        if (this.form.username === '') {
          this.showToast('手机号不能为空')
          return
        }
        if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.form.username)) {
          this.showToast('手机号格式错误')
          return
        }
        const _param = {
          'phoneNumber': this.form.username,
          'type': 1
        }
        this.$ajax.sendSMSCode(_param).then(res => {
          if (res.code === '0'){
            this.showToast('发送成功')
            this.countDown()
          } else {
            this.showToast(res.msg)
          }
        })
      },
      // 第一步跳转下一步
      goNext () {
        if (this.photoForm.cardImg === '') {
          this.showToast('请上传名片正面')
          return
        }
        if (this.photoForm.cardImgOpposite === '') {
          this.showToast('请上传名片背面')
          return
        }
        this.step = 2
      },
      // 显示提示
      showToast (text, time = 1000) {
        if (!text.trim()) {
          return
        }
        if (this.toast.timer) {
          clearTimeout(this.toast.timer)
        }
        this.toast.text = text
        this.toast.show = true
        this.toast.timer = setTimeout(() => {
          this.toast.show = false
        }, time)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/forgetPwd.vue